"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'recording.process.failed': '录音处理失败',
};
